import { render, staticRenderFns } from "./TicketingDetailTabs.vue?vue&type=template&id=bc1f51ec&scoped=true&"
import script from "./TicketingDetailTabs.vue?vue&type=script&lang=js&"
export * from "./TicketingDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./TicketingDetailTabs.vue?vue&type=style&index=0&id=bc1f51ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1f51ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDialog,VIcon,VTab,VTabItem,VTabs,VTabsItems})
